// extracted by mini-css-extract-plugin
export default {"Panels":"Panels_Panels__YxyiT"};